const CONSENT_ENDPOINT =
  "https://cbyrnessandbox.azurewebsites.net/api/ForgelightSaveConsent"

const USER_IP_ENDPOINT =
  "https://cbyrnessandbox.azurewebsites.net/api/GetUserIP"

const DEVICE_ID_KEY = "forgelight-device-id"
const IP_KEY = "forgelight-ip"
const POLICY_VERSION = "1"

export function getOrCreateDeviceId() {
  if (typeof window === "undefined") return null

  try {
    let id = window.localStorage.getItem(DEVICE_ID_KEY)
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `dev_${Date.now()}_${Math.random().toString(16).slice(2)}`
      window.localStorage.setItem(DEVICE_ID_KEY, id)
    }
    return id
  } catch {
    return `dev_ephemeral_${Date.now()}`
  }
}

export function getCachedIp() {
  if (typeof window === "undefined") return null
  try {
    return window.localStorage.getItem(IP_KEY)
  } catch {
    return null
  }
}

export async function fetchAndStoreUserIP() {
  if (typeof window === "undefined") return null

  try {
    const existing = window.localStorage.getItem(IP_KEY)
    if (existing) return existing
  } catch {}

  try {
    const response = await fetch(USER_IP_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({}),
    })

    if (!response.ok) {
      console.warn(
        `IP lookup failed: ${response.status} ${response.statusText}`
      )
      return null
    }

    const ip = await response.json().catch(() => null)

    if (ip) {
      try {
        window.localStorage.setItem(IP_KEY, ip)
      } catch {}
    }

    return ip
  } catch (err) {
    console.warn("IP lookup error:", err)
    return null
  }
}

export async function recordConsent({
  prefs,
  gpcDetected = false,
  source = "banner",
  choice,
  options,
}) {
  const deviceId = getOrCreateDeviceId()

  const payload = {
    deviceId,
    timestamp: new Date().toISOString(),
    prefs,
    gpcDetected,
    source,
    choice,
    options,
    policyVersion: POLICY_VERSION,
    ip: getCachedIp() || undefined,
    userAgent:
      typeof navigator !== "undefined" ? navigator.userAgent : undefined,
    pageUrl: typeof window !== "undefined" ? window.location.href : undefined,
  }

  try {
    const response = await fetch(CONSENT_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    })

    if (!response.ok) {
      console.warn(
        `Consent logging failed: ${response.status} ${response.statusText}`
      )
    }
  } catch (err) {
    console.warn("Consent logging error:", err)
  }
}